import ButtonWithTooltip from "@/components/ButtonWithTooltip"
import { TypographyH1, TypographyMuted } from "@/components/ui/typography" 
import { Clipboard, PlusCircle, RefreshCw } from "lucide-react"
import CardsResearch from "./components/CardsResearch"
import { useState } from "react"
import AddDialog from "./components/AddDialog"
import { useMarketResearchQuery } from "@/queries/useMarketResearchQuery"
import { AnimatePresence } from "framer-motion"
import TopMessage from "@/components/TopMessage"
import { useBaseStore } from '@/store'
import { Store } from '@/store/type'

const stateSelector = (state: Store) => ({ 
    profile: state.authSlice.state.profile
})


const MarketResearch = () => { 
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false)
    const onAddDialogClose = () => {
        setIsAddDialogOpen(false)
    }
    const { profile } = useBaseStore(stateSelector)
    
    const { data, isLoading, isFetching, refetch } = useMarketResearchQuery()

    return (
        <div className="flex  flex-col h-full overflow-auto p-4 bg-gray-50">
            <div className="md:flex-row flex-col  flex justify-between mb-4">
                <div className="flex flex-col gap-4 justify-between mb-4 sm:items-center sm:flex-row">
                    <div className="flex gap-3 items-center">
                        <div className="flex justify-center items-center w-10 h-10 rounded-lg bg-primary/10">
                            <Clipboard className="w-5 h-5 text-primary" />
                        </div>
                        <div>
                            <TypographyH1 className="text-2xl font-semibold">
                                Planejamento de Pesquisa
                            </TypographyH1>
                            <TypographyMuted>
                                Acompanhe e efetue suas pesquisa
                            </TypographyMuted>
                        </div>
                    </div>
                </div>

                <div className="flex justify-between gap-4">
                      {profile == 'ADMINISTRADOR' && (
                        <ButtonWithTooltip
                            className="flex items-center justify-center w-auto gap-2 px-4 rounded-md"
                            tooltipContent={<p>Adicionar</p>} 
                            onClick={() => setIsAddDialogOpen(true)}
                            size="default"
                        >
                            <PlusCircle size={18} />
                            Novo
                        </ButtonWithTooltip>
                    )}
                    <ButtonWithTooltip
                            tooltipContent={<p className="text-white">Atualizar</p>}
                            variant="ghost"
                            onClick={() => refetch()}
                            className="shadow  bg-white"
                        >
                            <RefreshCw size={18} /> 
                    </ButtonWithTooltip> 
                </div>
            </div>
            <AnimatePresence>
                {isLoading && (
                    <TopMessage
                        text="Carregando dados iniciais..."
                        variant="loading"
                        className="text-green-500 bg-green-100"
                    />
                )} 
                {isFetching && !isLoading && (
                    <TopMessage
                        text="Consultando os dados..."
                        variant="loading"
                        className="text-primary-500 bg-blue-100"
                    />
                )} 
            </AnimatePresence>
           
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
             
            
            {data && data.map( (research, index) => (  
                 <CardsResearch key={index} data={research} />
            ))} 
                 
            </div>
 
            <AddDialog onClose={onAddDialogClose} isOpen={isAddDialogOpen} />
        </div>
    )
}

export default MarketResearch
